import React from "react"

import moment from "moment"

import BaseTable from "./BaseTable"
import PaymentsTable from "./PaymentsTable"

import PillCell from "./cells/PillCell";
import BankAccountCell from "./cells/BankAccountCell";

import General from '../../../utils/General'
import Currency from "../../../utils/Currency";

import PayoutLineItemsTable from "./PayoutLineItemsTable";

const STATUS_FILTERS = {
  name: {
    api: "status",
    display: "status"
  },
  values: [
    {
      label: "All",
      value: null
    },
    {
      label: "Pending",
      value: "pending"
    },
    {
      label: "Paid",
      value: "paid"
    },
    {
      label: "Failed",
      value: "failedd"
    },
    {
      label: "Cancelled",
      value: "canceled"
    }
  ]
}

const FILTERS = [
  STATUS_FILTERS
]

export default class PayoutsTable extends React.Component {

  constructor(props){
    super(props)

    this.state = {
      dateFrom: props.dateFrom,
      dateTo: props.dateTo,
      company: props.company,
      processorSlugs: props.processorSlugs,
    }

    this.table = React.createRef()
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  _getColumns() {
    return [
      {
        Header: 'Paid Out',
        id: 'initiated_at',
        accessor: payout => moment(payout.initiated_at).format('DD MMM YYYY')
      },
      {
        Header: 'Processed',
        id: 'gross_amount',
        Cell: rowInfo => {
          let payout = rowInfo.original
          return Currency.format(payout.currency.symbol, payout.gross_amount)
        }
      },
      {
        Header: 'Fees',
        id: 'fee',
        Cell: rowInfo => {
          let payout = rowInfo.original
          return Currency.format(payout.currency.symbol, payout.fee)
        }
      },
      {
        Header: 'Deposit',
        id: 'amount',
        Cell: rowInfo => {
          let payout = rowInfo.original
          return Currency.format(payout.currency.symbol, payout.amount)
        }
      },
      {
        Header: 'Refunds',
        id: 'refunded_amount',
        Cell: rowInfo => {
          let payout = rowInfo.original
          return Currency.format(payout.currency.symbol, payout.refunded_amount)
        }
      },
      {
        Header: 'Status',
        id: 'status',
        Cell: rowInfo => {
          let payout = rowInfo.original
          let className = payout.status === 'paid' ? 'label-light-success' : 'label-light-danger'
          if(payout.status === 'pending'){
            className = 'label-light-primary'
          }

          return (
            <PillCell
              text={General.toTitleCase(payout.status)}
              className={className}
            />
          )
        }
      },
      {
        Header: 'Bank',
        id: 'bank_account.bank_name',
        Cell: rowInfo => {
          let payout = rowInfo.original

          return (
            <BankAccountCell
              bankAccount={payout.bank_account}
            />
          )
        }
      },
      {
        Header: 'Est. Arrival',
        id: 'expected_arrival_at',
        accessor: payout => moment(payout.expected_arrival_at).format('DD MMM YYYY')
      },
    ]
  }

  _renderPayments(payout){
    let {
      company,
      processorSlugs,
    } = this.state

    if(processorSlugs?.includes("adyen")){
      return (
        <PayoutLineItemsTable
          key={payout.id}
          payout={payout}
          company={company}
          tittle={`Transactions`}
          showExport={false}
        />
      )
    }

    return(
      <PaymentsTable
        payout={payout}
        title={`Payments`}
        showExport={false}
      />
    )
  }

  render() {
    let {
      company,
      processorSlugs,
    } = this.state

    const columns = this._getColumns()

    if(processorSlugs?.includes("adyen")){
      columns.splice(-2)
    }

    return (
      <div>
        <BaseTable
          ref={this.table}
          endpoint={`${window.Api.Payouts}?company_id=${company.id}&min_date=${this.state.dateFrom?.format('YYYY-MM-DD') || ''}&max_date=${this.state.dateTo?.format('YYYY-MM-DD') || ''}`}
          noDataMessage={"No payouts found"}
          title={"Payouts"}
          columns={columns}
          showExport={false}
          showObjectFilter={false}
          filters={FILTERS}
          defaultSorted={[
            {
              id: "initiated_at",
              desc: true
            }
          ]}
          SubComponent={row => this._renderPayments(row.original)}
        />
      </div>
    )
  }
}
